import React, { Component } from 'react'

export default class Mag004 extends Component {
  render() {
    return (
      <div>
      </div>
    )
  }
}
